"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSqrtBraces = void 0;
const tex_syntax_1 = require("./tex-syntax");
const unaryCommand = `\\\\(?:blueD|ce)`;
const arg = `(?:\\s+[^{]|${(0, tex_syntax_1.block)(2)})`;
const sqrtWithUnaryCommandArg = new RegExp(`(\\\\sqrt)(\\s*${unaryCommand}${arg})`, "g");
const sqrtWithDfracArg = new RegExp(`(\\\\sqrt)(\\s*\\\\dfrac${(0, tex_syntax_1.block)(2)}${(0, tex_syntax_1.block)(1)})`, "g");
function fixSqrtBraces(tex) {
    return tex
        .replace(sqrtWithUnaryCommandArg, "$1{$2}")
        .replace(sqrtWithDfracArg, "$1{$2}");
}
exports.fixSqrtBraces = fixSqrtBraces;
